import { motion } from "motion/react";

export function CompetitorRow({
  isHeader = false,
  platform,
  icon,
  overview,
  features,
  strengths,
  weaknesses,
  pricing,
  insights,
  highlight = false,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`${
        isHeader ? "hidden md:grid lg:grid" : ""
      } grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 p-4 md:p-6 border-b border-white/10 ${
        highlight ? "bg-[#fd5b38]/5 border-[#fd5b38]/50 rounded-lg" : ""
      }`}
    >
      {/* Platform */}
      <div className="lg:col-span-1 space-y-3">
        <div
          className={`${
            isHeader
              ? "lg:col-span-1 space-y-2"
              : "flex items-center gap-3 bg-[#0d0d0d] p-4 rounded-lg lg:h-full"
          }`}
        >
          {icon}
          <span
            className={`${
              isHeader ? "text-[#FD5B38] font-bold" : "text-white"
            }`}
          >
            <h5
              className={`${
                isHeader
                  ? "text-[#FD5B38] font-bold"
                  : "text-[#fd5b38] lg:hidden"
              }`}
            >
              Overview
            </h5>
            <p className="text-[#d1d5dc] text-sm leading-relaxed">{platform}</p>
          </span>
        </div>
      </div>

      {/* Overview */}
      <div className="lg:col-span-1 space-y-2">
        <h5
          className={`${
            isHeader ? "text-[#FD5B38] font-bold" : "text-[#fd5b38] lg:hidden"
          }`}
        >
          Overview
        </h5>
        <p className="text-[#d1d5dc] text-sm leading-relaxed">{overview}</p>
      </div>

      {/* Key Features */}
      <div className="lg:col-span-1 space-y-2">
        <h5
          className={`${
            isHeader ? "text-[#FD5B38] font-bold" : "text-[#fd5b38] lg:hidden"
          }`}
        >
          Key Features
        </h5>
        <p className="text-[#d1d5dc] text-sm leading-relaxed">{features}</p>
      </div>

      {/* Strengths */}
      <div className="lg:col-span-1 space-y-2">
        <h5
          className={`${
            isHeader ? "text-[#FD5B38] font-bold" : "text-[#fd5b38] lg:hidden"
          }`}
        >
          Strength(s)
        </h5>
        <p className="text-[#d1d5dc] text-sm leading-relaxed">{strengths}</p>
      </div>

      {/* Weaknesses */}
      <div className="lg:col-span-1 space-y-2">
        <h5
          className={`${
            isHeader ? "text-[#FD5B38] font-bold" : "text-[#fd5b38] lg:hidden"
          }`}
        >
          Weakness
        </h5>
        <p className="text-[#d1d5dc] text-sm leading-relaxed">{weaknesses}</p>
      </div>

      {/* Free vs Paid & Insights */}
      <div className="lg:col-span-1 space-y-4">
        <div className="space-y-2">
          <h5
            className={`${
              isHeader ? "text-[#FD5B38] font-bold" : "text-[#fd5b38] lg:hidden"
            }`}
          >
            Free vs Paid
          </h5>
          <p className="text-[#d1d5dc] text-sm leading-relaxed">{pricing}</p>
        </div>
        <div className="space-y-2 pt-2 border-t border-white/10 lg:border-0">
          <p className="text-[#d1d5dc] text-sm leading-relaxed">{insights}</p>
        </div>
      </div>
    </motion.div>
  );
}
